(() => {
  const bar = document.querySelector('[data-delivery-estimate-bar]');
  // The market's delivery options come from the one shared reader (bestio-delivery-options.js).
  const deliveryOptions = window.BestioDeliveryOptions;
  if (!bar || !deliveryOptions) return;

  const locale = document.documentElement.lang || 'cs-CZ';
  // The texts come from the theme locales (bestio.delivery_estimate, rendered by bestio-delivery-estimate.liquid).
  let texts;
  try { texts = JSON.parse(bar.dataset.deliveryEstimateTexts || ''); } catch (_) { return; }
  const text = (key, values) => Object.entries(values).reduce((result, [name, value]) => result.replace(`__${name}__`, value), String(texts[key] || ''));

  function date(value) { return value ? new Date(`${value}T12:00:00`) : null; }
  function formatDate(value) {
    return new Intl.DateTimeFormat(locale, {weekday: 'long', day: 'numeric', month: 'long'}).format(value);
  }
  function estimate(option) {
    if (!option?.estimatedDeliveryFrom) return null;
    return {
      methodCode: option.code,
      cutoff: option.orderByLocalTime,
      minDate: date(option.estimatedDeliveryFrom),
      maxDate: date(option.estimatedDeliveryTo || option.estimatedDeliveryFrom),
    };
  }
  function formatEstimate(value) {
    if (!value) return '';
    const from = formatDate(value.minDate);
    const to = formatDate(value.maxDate);
    return value.minDate.getTime() === value.maxDate.getTime() ? from : `${from} – ${to}`;
  }

  async function initialize() {
    const options = await deliveryOptions.load();
    const estimates = options.map(estimate).filter(Boolean);
    if (!estimates.length) return;
    const byCode = new Map(options.map((option) => [option.code, option]));
    const best = [...estimates].sort((a, b) => a.minDate - b.minDate || a.maxDate - b.maxDate)[0];
    bar.querySelector('[data-delivery-estimate-summary]').textContent = text('summary', {date: formatDate(best.minDate)});

    const threshold = deliveryOptions.freeShippingThreshold(options);
    const currency = deliveryOptions.currencyOf(options);
    const free = bar.querySelector('[data-delivery-estimate-free-shipping]');
    if (threshold != null && currency) free.textContent = text('freeFrom', {amount: deliveryOptions.formatMoney(threshold, currency, locale)});
    else free.hidden = true;

    const list = bar.querySelector('[data-delivery-estimate-list]');
    estimates.sort((a, b) => (byCode.get(a.methodCode)?.priority || 0) - (byCode.get(b.methodCode)?.priority || 0));
    estimates.forEach((value) => {
      const option = byCode.get(value.methodCode);
      const row = document.createElement('div');
      row.className = `bestio-delivery-estimate__row${option.logoUrl ? ' has-logo' : ''}`;
      if (option.logoUrl) {
        const logo = document.createElement('span');
        logo.className = 'bestio-delivery-estimate__row-logo';
        const image = document.createElement('img');
        image.src = option.logoUrl; image.alt = ''; image.loading = 'lazy';
        logo.appendChild(image); row.appendChild(logo);
      }
      const name = document.createElement('span'); name.className = 'bestio-delivery-estimate__row-name'; name.textContent = option.name;
      const cutoff = document.createElement('span'); cutoff.className = 'bestio-delivery-estimate__row-cutoff'; cutoff.textContent = text('orderBy', {time: value.cutoff});
      const delivery = document.createElement('span'); delivery.className = 'bestio-delivery-estimate__row-date'; delivery.textContent = text('expected', {date: formatEstimate(value)});
      row.append(name, cutoff, delivery); list.appendChild(row);
    });

    document.addEventListener('click', (event) => {
      const details = bar.querySelector('details');
      if (details?.open && !details.contains(event.target)) details.open = false;
    });
    bar.hidden = false;
  }

  initialize().catch(() => {});
})();
